import Vue from 'vue'

const eventBus = new Vue()

// 保存最近的 MQTT 消息（避免组件晚进来时错过消息）
eventBus._mqttMessageHistory = []
/**
 * 最大历史消息数量
 */
const MAX_HISTORY = 1

eventBus.$on = function(event, callback) {
  Vue.prototype.$on.call(this, event, callback)
}

eventBus.storeMqttMessage = function(msg) {
  this._mqttMessageHistory.push(msg)
  if (this._mqttMessageHistory.length > MAX_HISTORY) {
    this._mqttMessageHistory.shift()
  }
}

eventBus.getMqttHistory = function() {
  return [...this._mqttMessageHistory]
}

eventBus.clearMqttHistory = function() {
  this._mqttMessageHistory = []
}

export default eventBus
